import React from "react";
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Icon,
  Modal,
  Radio,
  RadioGroup,
  Typography,
  Card,
  FormHelperText,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import PropTypes from "prop-types";

export function NodeCreate({
  open,
  handleClose,
  isDisabled,
  getFieldValue,
  handleFieldChange,
  handleSubmit,
  isFieldValid,
  isFormModified,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "400px",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Card sx={style}>
        <MDBox
          mt={-7}
          color="white"
          bgColor="info"
          variant="gradient"
          borderRadius="lg"
          p={2}
          sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography id="modal-modal-title" component="h2">
            Crear nuevo nodo
          </Typography>
          <Icon
            sx={{
              fontSize: "2em",
              stroke: "currentColor",
              strokeWidth: "2px",
              cursor: "pointer",
              marginLeft: "auto",
            }}
            onClick={handleClose}>
            close
          </Icon>
        </MDBox>
        <Divider variant="middle" />
        <Typography id="modal-modal-title" variant="h5" component="h2">
          Nombre del nodo
        </Typography>
        <MDInput
          disabled={isDisabled}
          style={{ marginTop: "5px" }}
          value={getFieldValue("name")}
          error={!isFieldValid.name}
          helperText={
            getFieldValue("name") === "" && !isFieldValid.name
              ? "El campo no puede estar vacío"
              : !isFieldValid.name
              ? "No se permiten caracteres especiales"
              : ""
          }
          FormHelperTextProps={{ className: !isFieldValid.name ? "Mui-error" : "" }}
          onChange={(e) => handleFieldChange("name", e.target.value)}
        />
        
        <Typography id="modal-modal-title" variant="h5" component="h2" sx={{ mt: 2 }}>
          Municipio
        </Typography>
        <MDInput
          disabled={isDisabled}
          style={{ marginTop: "5px" }}
          value={getFieldValue("municipality")}
          error={!isFieldValid.municipality}
          helperText={
            getFieldValue("municipality") === "" && !isFieldValid.municipality
              ? "El campo no puede estar vacío"
              : !isFieldValid.municipality
              ? "No se permiten caracteres especiales"
              : ""
          }
          FormHelperTextProps={{ className: !isFieldValid.municipality ? "Mui-error" : "" }}
          onChange={(e) => handleFieldChange("municipality", e.target.value)}
        />
        
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: "flex", alignItems: "center", mt: 2, gap: 2 }}>
            <Typography id="modal-modal-description">
              Estado
            </Typography>
            <FormControl error={!isFieldValid.active}>
              <RadioGroup
                aria-labelledby="estado-nodo-radio-group"
                name="active"
                value={getFieldValue("active")}
                onChange={(e) => handleFieldChange("active", e.target.value === "true")}
                row>
                <FormControlLabel
                  disabled={isDisabled}
                  value={true}
                  control={<Radio />}
                  label="Activo"
                />
                <FormControlLabel
                  disabled={isDisabled}
                  value={false}
                  control={<Radio />}
                  label="Inactivo"
                />
              </RadioGroup>
              {!isFieldValid.active && <FormHelperText>Estado requerido</FormHelperText>}
            </FormControl>
          </Box>
          <Divider variant="middle" />
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              mt: 2,
            }}>
            <MDButton
              onClick={handleClose}
              color="error"
              sx={{
                flex: 1,
                mr: 1,
              }}>
              Cancelar
            </MDButton>
            <MDButton
              type="submit"
              color="success"
              disabled={isFormModified}
              sx={{
                flex: 1,
                mr: 1,
              }}>
              Crear
            </MDButton>
          </Box>
        </form>
      </Card>
    </Modal>
  );
}

NodeCreate.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  isDisabled: PropTypes.bool,
  getFieldValue: PropTypes.func,
  handleFieldChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  isFieldValid: PropTypes.shape({
    name: PropTypes.bool,
    municipality: PropTypes.bool,
    active: PropTypes.bool,
  }),
  isFormModified: PropTypes.bool,
};
